module.exports = __webpack_public_path__ + "img/dom.fca4b729.png";